import { render, staticRenderFns } from "./meeting-detail-report-table.vue?vue&type=template&id=22d98ad0&scoped=true"
import script from "./meeting-detail-report-table.vue?vue&type=script&lang=js"
export * from "./meeting-detail-report-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d98ad0",
  null
  
)

export default component.exports